import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { AgenciasService } from '../../_services/agencias.service';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.css']
})
export class DashboardAdminComponent implements OnInit {
  listAgencias = [];
  ventas = 0;
  nuevosUsuarios = 0;
  mes: string;
  cantidad: number;//Pendiente no me funciona

  constructor(
    private agenciasService:AgenciasService,
    private auxService:AuxiliarService,
    private modalService: NgbModal
    
  ) { }

  ngOnInit(): void {
    //cargar listado de agencias pendientes
    this.agenciasPendientes();
    this.totalVentas();
    this.mes = this.getMes(new Date().getMonth());
    this.totalUsers();
  }

  totalVentas(){
    this.agenciasService.totalVentasMes().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.ventas = data.body;
      }                      
    }); 
  }

  totalUsers(){
    this.agenciasService.totalNewUsers().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.nuevosUsuarios = data.body;
      }                       
    }); 
  }

  agenciasPendientes(){ //devuelve una lista con el id y el mombre de la agencia
    this.listAgencias = [];
    var limite = '6';
    this.agenciasService.agenciasPendientes(limite).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.cantidad = data.body.count;
        this.listAgencias = data.body.list;        
      }           
    });        
  }

  aprobar(id: string){
    this.agenciasService.aprobarAgencia(id).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        //Levantar un model
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.label = 'Volver'; 
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {
          modalRef.componentInstance.titulo = 'Agencia aprobada';
          modalRef.componentInstance.check = 1;
          this.agenciasPendientes();
          this.totalUsers();
        } else {
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';
          modalRef.componentInstance.check = 0;              
        }
      }
    });      
  }

  eliminar(id: string){
    this.agenciasService.rechazarAgencia(id).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.label = 'Volver'; 
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {
          modalRef.componentInstance.titulo = 'Agencia eliminada';
          modalRef.componentInstance.check = 1;
          this.agenciasPendientes();
        } else { 
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';  
          modalRef.componentInstance.check = 0;           
        }
      }
    });      
  }

  getMes(m: number): string{
    switch (m) {
      case 0: return 'Enero';
      case 1: return 'Febrero';
      case 2: return 'Marzo';
      case 3: return 'Abril';
      case 4: return 'Mayo';
      case 5: return 'Junio';
      case 6: return 'Julio';
      case 7: return 'Agosto';
      case 8: return 'Septiembre';
      case 9: return 'Octubre';
      case 10: return 'Noviembre';
      case 11: return 'Diciembre';
    }

  }



}
